import script from "./collabStatusBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./collabStatusBanner.vue?vue&type=script&setup=true&lang=ts"

import "./collabStatusBanner.vue?vue&type=style&index=0&id=48012637&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cow-app/cow-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48012637"]])

export default __exports__